const product = {
  slug: "szemelyi-kolcson",
  name: "Személyi kölcsön",
  description:
    "Pár perc alatt áttekintheted az elérhető személyi kölcsön ajánlatokat, hogy megtaláld a számodra legjobb havi törlesztőt.",
  highlights: [
    "Akár 15 millió forint hitelösszeg",
    "Gyors ajánlatok, átlátható feltételek",
    "Akár online igénylési folyamat",
    "Folyósítás akár 24 óra alatt",
    "Teljeskörű ügyinézés",
    "Költségek és THM egyszerű összevetése",
  ],
};

export default function SzemelyiKolcsonPage() {
  return (
    <main>
      <section className="hero-section product-hero">
        <div className="shell hero-split">
          <div>
            <h1>{product.name}</h1>
            <p className="hero-lead">{product.description}</p>
            <ul className="highlight-list">
              {product.highlights.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="iframe-card">
            <iframe
              id={`bm-iframe-${product.slug}`}
              title={`${product.name} kalkulátor`}
              scrolling="no"
              width="360"
              height="590"
              src="https://bankmonitor.hu/embed/szemelyi-hitel/?source=tasi_abel"
            />
          </div>
        </div>
      </section>

      <section className="info-section">
        <div className="shell info-grid">
          <article className="info-card">
            <h3>1. Érdeklődés és igényfelmérés</h3>
            <p>
              Néhány adat megadásával pontosabb képet kapsz arról, mely
              konstrukciók lehetnek megfelelőek a céljaidhoz.
            </p>
          </article>
          <article className="info-card">
            <h3>2. Ajánlatok összehasonlítása</h3>
            <p>
              Átláthatóan láthatod a költségeket és feltételeket, így könnyebb
              kiválasztani a legjobb ajánlatot.
            </p>
          </article>
          <article className="info-card">
            <h3>3. Szakértői támogatás</h3>
            <p>
              A döntés előtt és közben is segítséget kapsz, hogy magabiztosan
              haladj végig az igénylés folyamatán.
            </p>
          </article>
        </div>
      </section>
    </main>
  );
}
